export const googleAnalytics = "421168196"
export const googleTagManagerId = "GTM-ND8VHB34"
export const zapierWebhookUrl = "https://hooks.zapier.com/hooks/catch/12961765/3wlqy6o/"
export const microsoftClarityId = "kfhwqkm2yk"
